import Phaser from 'phaser';
import { GameScene } from './scenes/GameScene';
import { initFlags, getFlags } from './flags/launchdarkly';
import { initTouchControls } from './controls';
import { initOverlay, showUpdateBanner } from './ui';
import {
  startVersionWatcher,
  onVersionUpdateAvailable,
  reloadForUpdate
} from './version-watcher';

initTouchControls();
initOverlay();

startVersionWatcher();
onVersionUpdateAvailable(() => showUpdateBanner(reloadForUpdate));

initFlags()
  .catch((err) => {
    console.warn('[main] initFlags threw; continuing with defaults.', err);
    return getFlags();
  })
  .then(() => {
    const game = new Phaser.Game({
      type: Phaser.AUTO,
      parent: 'game',
      backgroundColor: '#5cb6ff',
      pixelArt: true,
      physics: {
        default: 'arcade',
        arcade: { gravity: { x: 0, y: 0 }, debug: false }
      },
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: window.innerWidth,
        height: window.innerHeight
      },
      scene: [GameScene]
    });

    // Make the canvas focusable so we can move focus off the start button when
    // the round begins. On macOS with Full Keyboard Access enabled, a focused
    // button intercepts the first arrow keydown for spatial navigation, which
    // makes the player feel sticky until the OS key-repeat kicks in.
    game.events.once(Phaser.Core.Events.READY, () => {
      const canvas = game.canvas;
      if (canvas) {
        canvas.setAttribute('tabindex', '0');
        canvas.style.outline = 'none';
      }
    });
  });
